import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PT from 'prop-types';
import classes from './JumpToWeek.css';
import { selectNFLScheduleState } from '../../../views/NFLSchedule/module/nflSchedule';
import WeekSelector from './WeekSelector/WeekSelector';

class JumpToWeek extends PureComponent {
  static propTypes = {
    selectedYear: PT.number.isRequired,
    onChangeWeek: PT.func,
    mediaType: PT.string.isRequired,
    currentWeek: PT.number,
  };

  static defaultProps = {
    onChangeWeek: null,
    selectedYear: 2021,
    currentWeek: 0,
  }

  render() {
    const { selectedYear, onChangeWeek, mediaType, currentWeek } = this.props;
    const numWeeks = selectedYear >= 2021 ? 18 : 17;
    const weeks = Array.from({ length: numWeeks + 1 }, (_, i) => i);
    return (
      <div className={classes.jumpToWeek}>
        <span>Jump to Week:</span>
        <WeekSelector
          weeks={weeks}
          onChangeWeek={onChangeWeek}
          mediaType={mediaType}
          currentWeek={currentWeek}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { year, currentWeek } = selectNFLScheduleState(state);
  return {
    selectedYear: year,
    mediaType: state.browser.mediaType,
    currentWeek,
  };
};

export default connect(mapStateToProps)(JumpToWeek);



// WEBPACK FOOTER //
// ./src/app/components/TableControls/JumpToWeek/JumpToWeek.js